"use strict";
/// <reference path="../../../../typings/ga.d.ts" />
/// <reference path="../../../../typings/gtag.d.ts" />
var eXpress;
(function (eXpress) {
    var analytics;
    (function (analytics) {
        const trackEvent = (category, action, eventParams, value) => {
            const dataLayer = window.dataLayer || [];
            dataLayer.push({
                event: action,
                event_category: category,
                event_label: JSON.stringify(eventParams),
                value: value
            });
            if (typeof gtag === 'function') {
                gtag('event', action, eventParams);
            }
            else if (typeof ga === 'function') {
                ga('technical.send', 'event', category, action, JSON.stringify(eventParams), value);
            }
        };
        function trackOrderStatusEvent(action, partialEventParams, nrOrdersInAccount = -1, nrItemsInOrder = -1) {
            const eventParams = Object.assign({ accountId: eXpress.utils.getCookie('accid') }, partialEventParams);
            trackEvent('OrderStatus', action, eventParams, nrOrdersInAccount > 0 ? nrOrdersInAccount : nrItemsInOrder);
        }
        analytics.trackOrderStatusEvent = trackOrderStatusEvent;
        function trackContactPageEvent(action) {
            trackEvent('ContactPage', action, {}, -1);
        }
        analytics.trackContactPageEvent = trackContactPageEvent;
        function trackAddressValidationEvent(action) {
            trackEvent('AddressValidation', action, {}, -1);
        }
        analytics.trackAddressValidationEvent = trackAddressValidationEvent;
        function trackMgmEvent(action) {
            trackEvent('MGMProgram', action, {}, -1);
        }
        analytics.trackMgmEvent = trackMgmEvent;
        function trackRecommendationCartEvent(action, cartRecommendationLabel) {
            trackEvent('Recommendations', action, cartRecommendationLabel ? cartRecommendationLabel : {}, -1);
        }
        analytics.trackRecommendationCartEvent = trackRecommendationCartEvent;
    })(analytics = eXpress.analytics || (eXpress.analytics = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var html;
    (function (html_1) {
        function querySelector(el, selectors, isRequired = false) {
            const resultEl = el.querySelector(selectors);
            if (isRequired && !resultEl)
                throw new Error(`querySelector didn't return any results for: ${selectors}`);
            return resultEl;
        }
        html_1.querySelector = querySelector;
        function remove(el) {
            if (el.parentElement)
                el.parentElement.removeChild(el);
        }
        html_1.remove = remove;
        function show(el) {
            if (el.offsetParent === null) { // is el visible in dom?
                if (el.style.display === 'none') { // check style attribute
                    el.style.display = '';
                }
                else {
                    if (getComputedStyle(el).display === 'none') { // el not visible -> check css display -> force display block
                        el.style.display = 'block';
                    }
                }
            }
        }
        html_1.show = show;
        function hide(el) {
            el.style.display = 'none';
        }
        html_1.hide = hide;
        function replaceWith(currentEl, newEl) {
            if (currentEl !== newEl && currentEl.parentNode) {
                currentEl.parentNode.replaceChild(newEl, currentEl);
            }
        }
        html_1.replaceWith = replaceWith;
        // TODO add requiredNotEmpty param (default false)
        function querySelectorAll(el, selectors) {
            return el ? [].slice.call(el.querySelectorAll(selectors)) : [];
        }
        html_1.querySelectorAll = querySelectorAll;
        function getParentWithClassName(el, className) {
            if (el)
                el = el.parentElement;
            while (el) {
                if (el.classList.contains(className))
                    return el;
                el = el.parentElement;
            }
            return null;
        }
        html_1.getParentWithClassName = getParentWithClassName;
        function getParentOrSelfWithClassName(el, className) {
            if (el) {
                if (el.classList.contains(className))
                    return el;
                else
                    el = el.parentElement;
            }
            while (el) {
                if (el.classList.contains(className))
                    return el;
                el = el.parentElement;
            }
            return null;
        }
        html_1.getParentOrSelfWithClassName = getParentOrSelfWithClassName;
        function loadImageAsync(url) {
            return loadImageAsyncImpl(new Image(), url);
        }
        html_1.loadImageAsync = loadImageAsync;
        const loadImageAsyncImpl = (image, url) => {
            const deferred = $.Deferred();
            function loaded() {
                unbindEvents();
                // Calling resolve means the image loaded sucessfully and is ready to use.
                deferred.resolve(image);
            }
            function errored() {
                unbindEvents();
                // Calling reject means we failed to load the image (e.g. 404, server offline, CORS, etc).
                // On error information available here
                deferred.reject(image);
            }
            function tryLoadImage() {
                // Setting the src property begins loading the image.
                try {
                    image.src = url;
                }
                catch (e) {
                    deferred.reject();
                }
            }
            function unbindEvents() {
                // Ensures the event callbacks only get called once.
                // temporary cast onerror as any: https://github.com/Microsoft/TypeScript/issues/29876
                image.onload = image.onerror = image.onabort = null;
            }
            // Set up event handlers to know when the image has loaded
            // or fails to load due to an error or abort.
            image.onload = loaded;
            image.onerror = errored; // URL returns 404, etc
            image.onabort = errored; // IE may call this if user clicks "Stop"
            tryLoadImage();
            return deferred;
        };
        /** addEventListener wrapper that catches and handles all exceptions thrown in the callback */
        function addEventListener(element, type, listener, useCapture) {
            const disposable = {
                dispose: () => {
                    if (disposable.handler) { // Prevent unregistering twice
                        element.removeEventListener(disposable.type, disposable.handler, useCapture);
                        // @ts-ignore
                        delete disposable.handler;
                    }
                },
                handler: (ev) => {
                    return listener(ev);
                },
                type
            };
            element.addEventListener(disposable.type, disposable.handler, useCapture);
            return disposable;
        }
        html_1.addEventListener = addEventListener;
        function disableUserEvents() {
            const eventsToBlock = ["click", "keydown", "keyup", "mouseenter", "mouseleave", "focus"];
            const disposable = {
                blockingEvents: eventsToBlock.map((event) => addEventListener(window, event, (e) => blockEvent(e), true)),
                dispose: () => {
                    if (disposable.blockingEvents) {
                        disposable.blockingEvents.forEach((blockedEvent) => blockedEvent.dispose());
                    }
                }
            };
            return disposable;
        }
        html_1.disableUserEvents = disableUserEvents;
        const blockEvent = (event) => {
            event.preventDefault();
            event.stopPropagation();
        };
        function addClass(element, cssClass) {
            toggleClass(element, cssClass, true);
        }
        html_1.addClass = addClass;
        function removeClass(element, cssClass) {
            toggleClass(element, cssClass, false);
        }
        html_1.removeClass = removeClass;
        function toggleClass(element, cssClass, on) {
            const regex = new RegExp('(?:^|\\s)' + cssClass + '(?!\\S)');
            const hasClass = element.className.match(regex);
            if (hasClass && !on) {
                element.className = element.className.replace(new RegExp(regex.source, "g"), '');
            }
            else if (!hasClass && on) {
                element.className += " " + cssClass;
            }
        }
        html_1.toggleClass = toggleClass;
        function hasClass(element, cssClass) {
            const regex = new RegExp('(?:^|\\s)' + cssClass + '(?!\\S)');
            const match = element.className.match(regex);
            return !!match && !!match.length;
        }
        html_1.hasClass = hasClass;
        function getWindowSize() {
            const w = window;
            const d = document;
            const e = d.documentElement;
            const g = d.body;
            const x = w.innerWidth || e.clientWidth || g.clientWidth;
            const y = w.innerHeight || e.clientHeight || g.clientHeight;
            return { width: x, height: y };
        }
        html_1.getWindowSize = getWindowSize;
        function isElementVisible(el) {
            return !(el.offsetWidth
                + el.offsetHeight
                + el.getBoundingClientRect().height
                + el.getBoundingClientRect().width === 0);
        }
        html_1.isElementVisible = isElementVisible;
        function fixBackButton() {
            window.onunload = () => {
                // fix back button
            };
        }
        html_1.fixBackButton = fixBackButton;
        function getHeightWithMargins(el) {
            return el.getBoundingClientRect().height
                + parseInt(window.getComputedStyle(el).marginTop || "0", 10)
                + parseInt(window.getComputedStyle(el).marginBottom || "0", 10);
        }
        html_1.getHeightWithMargins = getHeightWithMargins;
        function getWidthWithMargins(el) {
            return el.getBoundingClientRect().width
                + parseInt(window.getComputedStyle(el).marginLeft || "0", 10)
                + parseInt(window.getComputedStyle(el).marginRight || "0", 10);
        }
        html_1.getWidthWithMargins = getWidthWithMargins;
        let inViewArray;
        function inViewTrigger(element, callBack) {
            const inViewScrollHandler = () => {
                // What does in view mean? We assume people are scrolling down, so if BOTTOM of the element is in view -> the element has been in view!
                for (let i = inViewArray.length - 1; i >= 0; i--) {
                    const { element, callBack } = inViewArray[i];
                    const windowHeight = window.innerHeight;
                    const scrollY = window.scrollY || window.pageYOffset;
                    const scrollPosition = scrollY + windowHeight;
                    const elementHeight = element.clientHeight;
                    const elementPosition = element.getBoundingClientRect().top + scrollY + elementHeight;
                    if (scrollPosition > elementPosition) {
                        callBack(element);
                        inViewArray.splice(i, 1);
                    }
                }
                if (inViewArray.length === 0) {
                    // I no longer need myself! Cleanup....
                    document.removeEventListener('scroll', inViewScrollHandler);
                }
            };
            // We should only have 1 scroll eventlistener that checks all elements that want to use this feature.
            if (!inViewArray || inViewArray.length === 0) {
                inViewArray = [];
                document.addEventListener('scroll', inViewScrollHandler);
            }
            inViewArray.push({ element, callBack });
            // Do 1 check without scrolling -> items might already be completely in view
            inViewScrollHandler();
        }
        html_1.inViewTrigger = inViewTrigger;
        function sanitize(html) {
            return html.replace(/[^\w. ]/gi, function (c) {
                return '&#' + c.charCodeAt(0) + ';';
            });
        }
        html_1.sanitize = sanitize;
        function isMobileOnPageWithHeader() {
            return html.isElementVisible(html.querySelector(document, '.technical-mobile-navigation-hamburger-menu-button', true));
        }
        html_1.isMobileOnPageWithHeader = isMobileOnPageWithHeader;
        function isMobile() {
            return (window.innerWidth <= 960 && window.innerHeight <= 960);
        }
        html_1.isMobile = isMobile;
        function htmlToElement(html) {
            const template = document.createElement('template');
            html = html.trim(); // Never return a text node of whitespace as the result
            template.innerHTML = html;
            return template.content.firstChild;
        }
        html_1.htmlToElement = htmlToElement;
        const isElementGenerallyVisible = (element) => {
            const style = window.getComputedStyle(element);
            return style.display !== "none" && style.visibility !== "hidden" && style.opacity !== "0";
        };
        function isElementVisibleInViewPort(el) {
            if (!el)
                return false; // return default
            const rect = el.getBoundingClientRect();
            return (rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth));
        }
        html_1.isElementVisibleInViewPort = isElementVisibleInViewPort;
        function isElementFullyVisible(element) {
            return isElementGenerallyVisible(element) && isElementVisibleInViewPort(element) && element.checkVisibility();
        }
        html_1.isElementFullyVisible = isElementFullyVisible;
        function onElementVisibleOrBecomeVisible(el, onVisible) {
            if (!onVisible)
                return;
            const isFullyVisible = isElementFullyVisible(el);
            if (isFullyVisible) {
                onVisible && onVisible();
            }
            else {
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            onVisible && onVisible();
                            observer.disconnect();
                        }
                    });
                });
                observer.observe(el);
            }
        }
        html_1.onElementVisibleOrBecomeVisible = onElementVisibleOrBecomeVisible;
    })(html = eXpress.html || (eXpress.html = {}));
})(eXpress || (eXpress = {}));
if (!Element.prototype.toggleAttribute) {
    Element.prototype.toggleAttribute = function (name, force) {
        if (force !== void 0)
            force = !!force;
        if (this.hasAttribute(name)) {
            if (force)
                return true;
            this.removeAttribute(name);
            return false;
        }
        if (force === false)
            return false;
        this.setAttribute(name, "");
        return true;
    };
}
if (!Element.prototype.matches) {
    //@ts-ignore
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        let el = this;
        do {
            if (Element.prototype.matches.call(el, s))
                return el;
            //@ts-ignore
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}
// Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/append()/append().md
(function (arr) {
    arr.forEach(function (item) {
        if (Object.prototype.hasOwnProperty.call(item, 'append')) {
            return;
        }
        Object.defineProperty(item, 'append', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function append(...args) {
                const docFrag = document.createDocumentFragment();
                args.forEach(function (argItem) {
                    const isNode = argItem instanceof Node;
                    docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                });
                this.appendChild(docFrag);
            }
        });
    });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function isAuthenticationCheck(accountId) {
            const emptyGuid = '00000000-0000-0000-0000-000000000000';
            let isStillAtuhenticated = true;
            if (!accountId)
                isStillAtuhenticated = false;
            if (accountId === emptyGuid)
                isStillAtuhenticated = false;
            return isStillAtuhenticated;
        }
        utils.isAuthenticationCheck = isAuthenticationCheck;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function getCookie(cName) {
            const allCookies = document.cookie;
            if (allCookies.length > 0) {
                let cStart = allCookies.indexOf(cName + "=");
                if (cStart !== -1) {
                    cStart = cStart + cName.length + 1;
                    let cEnd = allCookies.indexOf(";", cStart);
                    if (cEnd === -1)
                        cEnd = allCookies.length;
                    return unescape(allCookies.substring(cStart, cEnd));
                }
            }
            return "";
        }
        utils.getCookie = getCookie;
        function writeCookie(cName, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            const expires = "expires=" + d.toUTCString();
            document.cookie = cName + "=" + cvalue + ";" + expires + "; path=/";
        }
        utils.writeCookie = writeCookie;
        function writeCookieThatExpiresAtTheEndOfTheDay(cName, cValue) {
            const d = new Date();
            const midnight = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59);
            const expires = "expires=" + midnight.toUTCString();
            document.cookie = encodeURIComponent(cName) + "=" + encodeURIComponent(cValue) + ";" + expires + "; path=/";
        }
        utils.writeCookieThatExpiresAtTheEndOfTheDay = writeCookieThatExpiresAtTheEndOfTheDay;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        const countryCodes = {
            'aut': '+43',
            'bel': '+32',
            'deu': '+49',
            'dnk': '+45',
            'che': '+41',
            'fin': '+358',
            'fra': '+33',
            'gbr': '+44',
            'irl': '+353',
            'lux': '+352',
            'nld': '+31',
            'nor': '+47',
            'swe': '+46'
        };
        function FillPhoneWithCountryPrefixWhenEmpty(countrycode) {
            var _a;
            return !countrycode ? '' : (_a = countryCodes[countrycode.toLowerCase()]) !== null && _a !== void 0 ? _a : ''; // default empty string
        }
        utils.FillPhoneWithCountryPrefixWhenEmpty = FillPhoneWithCountryPrefixWhenEmpty;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function debounce(fn, delay) {
            let timeoutID = 0;
            const callable = (...args) => {
                clearTimeout(timeoutID);
                // eslint-disable-next-line prefer-spread
                timeoutID = window.setTimeout(() => fn.apply(null, args), delay);
            };
            return callable;
        }
        utils.debounce = debounce;
        function throttle(fn, delay) {
            let lastTimestamp = 0;
            const callable = (...args) => {
                const now = Date.now();
                if (!lastTimestamp || now - lastTimestamp >= delay) {
                    lastTimestamp = now;
                    fn(...args);
                }
            };
            return callable;
        }
        utils.throttle = throttle;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function isTouchDevice() {
            let result = false;
            if (window.PointerEvent && ('maxTouchPoints' in navigator)) {
                if (navigator.maxTouchPoints > 0) {
                    result = true;
                }
            }
            else {
                if (window.matchMedia && window.matchMedia("(any-pointer:coarse)").matches) {
                    result = true;
                }
                else if (window.TouchEvent || ('ontouchstart' in window)) {
                    result = true;
                }
            }
            return result;
        }
        utils.isTouchDevice = isTouchDevice;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        /** Returns a composite disposable (disposing all child disposables) */
        function compositeDisposable(disposables) {
            // TODO: This creates a closure, optimize?
            let composite = {
                dispose() {
                    if (composite) {
                        // To avoid endless loops when calling dispose on the composite again, we first clear it.
                        composite = null;
                        if (disposables)
                            disposables.forEach(d => d.dispose());
                    }
                },
                add(addDisposables) {
                    if (!disposables)
                        disposables = [];
                    disposables.push(...addDisposables);
                }
            };
            return composite;
        }
        utils.compositeDisposable = compositeDisposable;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function getHttpResponse(path, config) {
            return __awaiter(this, void 0, void 0, function* () {
                const request = new Request(path.toLowerCase(), config);
                const response = yield fetch(request);
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response;
            });
        }
        utils.getHttpResponse = getHttpResponse;
        const httpText = (path, config) => __awaiter(this, void 0, void 0, function* () {
            const response = yield getHttpResponse(path.toLowerCase(), config);
            return response.ok ? response.text() : '';
        });
        function getHtmlRequest(path, config) {
            return __awaiter(this, void 0, void 0, function* () {
                const init = Object.assign({ method: 'get' }, config);
                return yield httpText(path, init);
            });
        }
        utils.getHtmlRequest = getHtmlRequest;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function createGtmMutationObserver(targetNode, seconds) {
            return new Promise((resolve, reject) => {
                const observer = new MutationObserver((mutations, obs) => {
                    obs.disconnect();
                    clearTimeout(timeout);
                    resolve(mutations);
                });
                observer.observe(targetNode, { childList: true, subtree: true });
                const timeout = setTimeout(() => {
                    observer.disconnect();
                    reject("Nothing happened! (Emarsys recommendations do not work)");
                }, seconds * 1000);
            });
        }
        utils.createGtmMutationObserver = createGtmMutationObserver;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function getGuid() {
            let d = new Date().getTime(); // Timestamp
            let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0; // Time in microseconds since page-load or 0 if unsupported
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                /* tslint:disable:no-bitwise */
                let r = Math.random() * 16; // random number between 0 and 16
                if (d > 0) { // Use timestamp until depleted
                    r = (d + r) % 16 | 0;
                    d = Math.floor(d / 16);
                }
                else { // Use microseconds since page-load if supported
                    r = (d2 + r) % 16 | 0;
                    d2 = Math.floor(d2 / 16);
                }
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                /* tslint:enable:no-bitwise */
            });
        }
        utils.getGuid = getGuid;
        function newSliderGuid() {
            return 'sxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }
        utils.newSliderGuid = newSliderGuid;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        const getInlineSvgAsync = (url) => {
            const deferred = $.Deferred();
            $.ajax(url, { dataType: 'xml' })
                .then(data => {
                const document = data;
                if (document && document.documentElement.nodeName.toLowerCase() === 'svg') {
                    const svgString = new XMLSerializer().serializeToString(document);
                    deferred.resolve({
                        url,
                        svg: svgString
                    });
                }
                else {
                    deferred.resolve(undefined);
                }
            }, (jqXhr, status, error) => {
                if (window && window.onerror)
                    window.onerror(`Icon not found on : ${url} , ${status.indexOf('parser') !== -1 ? "not an icon" : status}`);
                deferred.resolve(undefined);
            });
            return deferred.promise();
        };
        function getInlineSvgsAsync(urls) {
            return utils.whenAll(urls.map(u => getInlineSvgAsync(u)))
                .then(items => items.filter(item => !!item));
        }
        utils.getInlineSvgsAsync = getInlineSvgsAsync;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function showLoadingDialog(promise, timeToShowLoadingDialog = 200, extraTimeOutAfterResolving, timeoutToDisableLoadingDialog) {
            const bodyEl = eXpress.html.querySelector(document, "body", true);
            const dialogEl = eXpress.html.querySelector(bodyEl, ".technical-loading-dialog", true);
            const toggleClasses = (show) => {
                eXpress.html.toggleClass(dialogEl, "u-hide", !show);
            };
            const show = setTimeout(() => toggleClasses(true), timeToShowLoadingDialog);
            const blockingEventDisposables = eXpress.html.disableUserEvents();
            let manualTimeoutToDisableLoadingDialog;
            const disableLoadingDialog = () => {
                clearTimeout(show);
                if (manualTimeoutToDisableLoadingDialog)
                    clearInterval(manualTimeoutToDisableLoadingDialog);
                blockingEventDisposables.dispose();
                toggleClasses(false);
            };
            if (timeoutToDisableLoadingDialog)
                manualTimeoutToDisableLoadingDialog = setInterval(() => disableLoadingDialog(), timeoutToDisableLoadingDialog);
            return promise.done(() => {
                if (extraTimeOutAfterResolving)
                    setTimeout(() => disableLoadingDialog(), extraTimeOutAfterResolving);
                else
                    disableLoadingDialog();
            });
        }
        utils.showLoadingDialog = showLoadingDialog;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        const hasLocalStorage = isLocalStorageSupported();
        function isLocalStorageSupported() {
            if (typeof window === "undefined")
                return false;
            try {
                return typeof window.localStorage !== "undefined";
            }
            catch (_a) {
                return false;
            }
        }
        utils.isLocalStorageSupported = isLocalStorageSupported;
        function setLocalStorageItem(key, value, scope, expiry) {
            if (!hasLocalStorage)
                return;
            if (!expiry) {
                window.localStorage.setItem(key, JSON.stringify({ value: value, scope: scope }));
            }
            else {
                window.localStorage.setItem(key, JSON.stringify({ value: value, scope: scope, expiry: expiry.getTime() }));
            }
        }
        utils.setLocalStorageItem = setLocalStorageItem;
        function getLocalStorageItem(key, scope) {
            if (!hasLocalStorage)
                return null;
            const item = window.localStorage.getItem(key);
            if (!item)
                return null;
            let parsedItem;
            try {
                parsedItem = JSON.parse(item);
            }
            catch (_a) {
                window.localStorage.removeItem(key); // optional cleanup
                return null;
            }
            const isExpired = (expiry) => {
                return typeof expiry === "number" && new Date().getTime() > expiry;
            };
            if (parsedItem.scope && parsedItem.scope !== scope) {
                window.localStorage.removeItem(key);
                return null;
            }
            if (isExpired(parsedItem.expiry)) {
                window.localStorage.removeItem(key);
                return null;
            }
            return parsedItem.value;
        }
        utils.getLocalStorageItem = getLocalStorageItem;
        function removeLocalStorageItem(key) {
            if (!hasLocalStorage)
                return;
            window.localStorage.removeItem(key);
        }
        utils.removeLocalStorageItem = removeLocalStorageItem;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function calculateAndSetHeightOfMobileNavigationLevel(mobileNavigationLevel) {
            mobileNavigationLevel.style.height = '100vh';
            // Calculate height of lvl menu (without browser bars)
            const browserUiBars = mobileNavigationLevel.getBoundingClientRect().height - window.innerHeight;
            const menuItemsLvlPositionTop = document.body.getBoundingClientRect().top - mobileNavigationLevel.getBoundingClientRect().top;
            // Set height of level menu items to correct size calculated
            mobileNavigationLevel.style.height = 'calc(100vh - ' + Math.abs(browserUiBars) + 'px + ' + menuItemsLvlPositionTop + 'px)';
        }
        utils.calculateAndSetHeightOfMobileNavigationLevel = calculateAndSetHeightOfMobileNavigationLevel;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function checkPersonalNumber(pin, regionCode) {
            if (pin.trim() === "")
                return true;
            switch (regionCode) {
                case "SWE":
                    return checksumSe(pin);
                case "NOR":
                    return checksumNo(pin);
                case "DNK":
                    return checksumDk(pin);
                case "FIN":
                    return checksumFi(pin);
                default:
                    return true;
            }
        }
        utils.checkPersonalNumber = checkPersonalNumber;
        const checksumDk = (pin) => {
            if (pin && pin.length === 11) {
                const checkSumString = "4327654321";
                let result1 = 0;
                const temp = pin.toString().substring(0, 6) + pin.toString().substring(7, 10);
                for (let i = 0; i < 9; i++) {
                    result1 += parseInt(checkSumString[i].toString(), 10) * parseInt(temp[i].toString(), 10);
                }
                let checksum = 11 - result1 % 11;
                if (checksum === 11)
                    checksum = 0;
                if (checksum.toString() === pin[10])
                    return true;
                else
                    return false;
            }
            else {
                return false;
            }
        };
        const checksumFi = (pin) => {
            if (pin && pin.length === 11) {
                const checkSumString = "0123456789ABCDEFHJKLMNPRSTUVWXY";
                const temp = parseInt(pin.toString().substring(0, 6) + pin.toString().substring(7, 10), 10);
                const result1 = temp % 31;
                const checksum = checkSumString[result1];
                if (checksum === pin[10])
                    return true;
                else
                    return false;
            }
            else {
                return false;
            }
        };
        const checksumNo = (pin) => {
            if (pin && pin.length === 12) {
                let result1 = 0;
                let result2 = 0;
                const checkSumString1 = "376189-452";
                const checkSumString2 = "543276-5432";
                for (let i = 0; i < 10; i++) {
                    if (i === 6)
                        continue;
                    result1 += parseInt(checkSumString1[i].toString(), 10) * parseInt(pin[i].toString(), 10);
                }
                let checksum1 = 11 - result1 % 11;
                if (checksum1 === 11)
                    checksum1 = 0;
                if (checksum1.toString() !== pin[10])
                    return false;
                for (let i = 0; i < 11; i++) {
                    if (i === 6)
                        continue;
                    result2 += parseInt(checkSumString2[i].toString(), 10) * parseInt(pin[i].toString(), 10);
                }
                let checksum2 = 11 - result2 % 11;
                if (checksum2 === 11)
                    checksum2 = 0;
                if (checksum2.toString() !== pin[11])
                    return false;
                else
                    return true;
            }
            else {
                return false;
            }
        };
        const checksumSe = (pin) => {
            const orignalPin = pin;
            if (!pin || pin.length !== 13)
                return false;
            let result1 = 0;
            const multiplier = "212121-212".split('').map(s => +s); // convert string to number using +
            let temp = 0;
            // format must be 123456-1234
            if (pin.length === 13)
                pin = pin.toString().substring(2);
            const pins = pin.split('').map(s => +s);
            for (let i = 0; i < 10; i++) {
                if (i === 6)
                    continue;
                temp = multiplier[i] * pins[i];
                if (temp > 9)
                    result1 += parseInt(temp.toString().split('')[0], 10) + parseInt(temp.toString().split('')[1], 10);
                else
                    result1 += temp;
            }
            const lastDigit = parseInt(result1.toString().split('')[result1.toString().length - 1], 10);
            let checksum;
            if (lastDigit === 0)
                checksum = 0;
            else
                checksum = 10 - lastDigit;
            if (checksum === pins[10])
                return birthdaySe(orignalPin);
            else
                return false;
        };
        const birthdaySe = (pin) => {
            const regExp = new RegExp(/^(?:((?:19|20)?\d\d))([01]\d)(\d\d)([-+]?)(\d\d|TF)(\d)(\d)$/);
            const result = regExp.test(pin);
            return result;
        };
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function getPriceString(amount, setup) {
            let result = '';
            if (setup.displayLeftToPrice)
                result += setup.currencySymbol + ' ';
            result += amount.toFixed(2).replace('.', setup.decimalSeparator);
            if (!setup.displayLeftToPrice)
                result += ' ' + setup.currencySymbol;
            return result;
        }
        utils.getPriceString = getPriceString;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function whenAll(promises) {
            return $.when(...promises).then((...items) => items);
        }
        utils.whenAll = whenAll;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function getFullQuerystring(url) {
            url = url || window.location.href;
            const pos = url.indexOf("?");
            if (pos > -1) {
                return url.substring(pos + 1);
            }
            else {
                return url;
            }
        }
        utils.getFullQuerystring = getFullQuerystring;
        function getParameters(url) {
            const queryString = eXpress.utils.getFullQuerystring(url);
            // remove hash parameter and split querystring param
            const pairs = queryString.split('#')[0].split("&");
            const params = {};
            for (const pair of pairs) {
                const [key, value] = pair.split("=");
                params[key.toLowerCase()] = value !== undefined ? value : "true"; // Providing just the key means key=true
            }
            return params;
        }
        utils.getParameters = getParameters;
        function getParameter(key, url, required = false) {
            const queryStringParam = eXpress.utils.getParameters(url)[key.toLowerCase()];
            if (required && !queryStringParam)
                throw new Error(`No queryStringParam for Required key: ${key}`);
            return queryStringParam;
        }
        utils.getParameter = getParameter;
        function updateParameter(key, value, url) {
            url = url || window.location.href;
            let newAdditionalURL = "";
            let tempArray = url.split("#");
            const hash = tempArray[1] ? tempArray[1] : '';
            const additionalURL = tempArray[0] ? tempArray[0].split("?")[1] : '';
            const baseURL = tempArray[0] ? tempArray[0].split("?")[0] : '';
            let temp = "";
            if (additionalURL) {
                tempArray = additionalURL.split("&");
                for (let i = 0; i < tempArray.length; i++) {
                    if (tempArray[i].split('=')[0] !== key) {
                        newAdditionalURL += temp + tempArray[i];
                        temp = "&";
                    }
                }
            }
            let result = temp;
            if (value)
                result += "" + key + "=" + value;
            else
                result = result.substring(0, result.length - 1);
            if (!newAdditionalURL && !result)
                return baseURL + (hash ? '#' + hash : '');
            return baseURL + "?" + newAdditionalURL + result + (hash ? '#' + hash : '');
        }
        utils.updateParameter = updateParameter;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function resolveVersionedUrlCdn(path, file) {
            // @ts-ignore
            const context = window.context;
            if (!context)
                return path + file;
            if (context.versionedStaticPaths === "true")
                return context.cdn + path + context.revision + '/' + file;
            return context.cdn + path + file + ((context.revision) ? '?' + context.revision : '');
        }
        utils.resolveVersionedUrlCdn = resolveVersionedUrlCdn;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function capitalizeFirstLetterOfWords(input) {
            const words = input.split(" ");
            for (let i = 0; i < words.length; i++) {
                words[i] = words[i][0].toUpperCase() + words[i].substr(1).toLowerCase();
            }
            return words.join(" ");
        }
        utils.capitalizeFirstLetterOfWords = capitalizeFirstLetterOfWords;
        function onlyLetters(input) {
            return Boolean(input.match(/^[A-Za-z]*$/));
        }
        utils.onlyLetters = onlyLetters;
        function onlyNumber(input) {
            return Boolean(input.match(/^[0-9]*$/));
        }
        utils.onlyNumber = onlyNumber;
        function stringToBase64(inputString) {
            const bytes = new TextEncoder().encode(inputString);
            const binString = Array.from(bytes, (byte) => String.fromCodePoint(byte)).join("");
            return window.btoa(binString);
        }
        utils.stringToBase64 = stringToBase64;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function isValidNumberAfterKeyPress(event, min, max) {
            const keyNr = event.keyCode || event.which;
            if (keyNr !== 8 && keyNr !== 9 && keyNr !== 13 && keyNr !== 16 && keyNr !== 17 && keyNr !== 18) {
                const key = String.fromCharCode(keyNr);
                let newValue;
                const textbox = event.target;
                // if the old value - or part of the old value - was selected, this need to be stripped of the result (see else)
                // if the cursor is not at the end of the text, new char needs to be inserted at cursor position. (see else)
                if (!textbox.selectionStart && !textbox.selectionEnd) {
                    newValue = textbox.value + key;
                }
                else {
                    const val1 = textbox.value.substr(0, (textbox.selectionStart || 0));
                    const val2 = textbox.value.substr(textbox.selectionEnd || 0);
                    // concat text in before selection start, the new char and the text after selection end.
                    newValue = val1 + key + val2;
                }
                // Regex -> only numbers
                const regex = new RegExp("[^0-9]", 'g');
                const intValue = parseInt(newValue, 10);
                if (newValue.match(regex) || isNaN(intValue) || intValue > max || intValue < min) {
                    event.returnValue = false;
                    if (event.preventDefault)
                        event.preventDefault();
                    return false;
                }
            }
            return true;
        }
        utils.isValidNumberAfterKeyPress = isValidNumberAfterKeyPress;
        function doGetCaretPosition(ctrl) {
            let caretPos = 0;
            if (ctrl.selectionStart || ctrl.selectionStart === 0) { // Standard.
                caretPos = ctrl.selectionStart;
            }
            return caretPos;
        }
        utils.doGetCaretPosition = doGetCaretPosition;
        function isValidTextWithoutAngleBrackets(text) {
            if (!text)
                return false;
            return new RegExp("^[^<>]+$").test(text);
        }
        utils.isValidTextWithoutAngleBrackets = isValidTextWithoutAngleBrackets;
        function setCaretPosition(ctrl, pos) {
            if (ctrl.setSelectionRange) {
                ctrl.focus();
                ctrl.setSelectionRange(pos, pos);
            }
        }
        utils.setCaretPosition = setCaretPosition;
        function vatNumberHasCorrectCountryCode(vatNumber, countryCode) {
            if (countryCode.toLowerCase() !== 'bel'
                && countryCode.toLowerCase() !== 'ndl'
                && countryCode.toLowerCase() !== 'che'
                && countryCode.toLowerCase() !== 'swe')
                return true;
            let testVal = '';
            switch (countryCode.toLowerCase()) {
                case 'bel':
                    testVal = vatNumber.substring(0, 2);
                    if (utils.onlyNumber(testVal))
                        return true;
                    return (utils.onlyLetters(testVal) && testVal.toLowerCase() === 'be');
                    break;
                case 'ndl':
                    testVal = vatNumber.substring(0, 2);
                    if (utils.onlyNumber(testVal))
                        return true;
                    return (utils.onlyLetters(testVal) && testVal.toLowerCase() === 'nl');
                    break;
                case 'che':
                    testVal = vatNumber.substring(0, 3);
                    if (utils.onlyNumber(testVal))
                        return true;
                    return (utils.onlyLetters(testVal) && testVal.toLowerCase() === 'che');
                    break;
                case 'swe':
                    testVal = vatNumber.substring(0, 2);
                    if (utils.onlyNumber(testVal))
                        return true;
                    return (utils.onlyLetters(testVal) && testVal.toLowerCase() === 'se');
                    break;
            }
        }
        utils.vatNumberHasCorrectCountryCode = vatNumberHasCorrectCountryCode;
        function isValidVatNumber(input, countryCode) {
            if (vatNumberHasCorrectCountryCode(input, countryCode)) {
                if (countryCode.toLowerCase() !== 'bel')
                    return true;
                const vatNumber = input.match(/\d/g);
                let vatNumberString = '';
                if (vatNumber)
                    vatNumberString = vatNumber.join('');
                const part1 = parseInt(vatNumberString.substring(0, vatNumberString.length - 2), 10);
                const part2 = parseInt(vatNumberString.substring(vatNumberString.length - 2), 10);
                const temp = part1 - parseInt((part1 / 97) + "", 10) * 97;
                return 97 - temp === part2;
            }
            return false;
        }
        utils.isValidVatNumber = isValidVatNumber;
        function isValidWithoutNonAlphaNumericCharsAtEnd(text, el) {
            // Our zipcode db contains values like 'ANTWERPEN (2000)' as city => these should be valid => if last == ) return true
            const reg = new RegExp('^[\\p{L}\\p{N}]*$', 'u');
            const elName = el.getAttribute("name") || "";
            // Why trim? We allow spaces as we trim those in the backend code
            const alsoAlsoAllowBracket = elName && elName.toLowerCase().indexOf('city') !== -1;
            const last = text.trim().charAt(text.trim().length - 1);
            return reg.test(last) || (alsoAlsoAllowBracket && last === ')') || last === '.';
        }
        utils.isValidWithoutNonAlphaNumericCharsAtEnd = isValidWithoutNonAlphaNumericCharsAtEnd;
        function isValidEmailAddress(email) {
            // tslint:disable-next-line:max-line-length
            const sValidEmail = '^((([a-zA-Z]|\\d|!|#|\\$|\\[|\\]|%|&|\'|\\\\|\\/|\\+|\\-|=|\\?|\\^|\\*|_|{|}|`|\\||~)+(\\.([a-zA-Z]|\\d|!|#|\\$|\\[|\\]|%|&|\'|\\\\|\\/|\\+|\\-|=|\\?|\\^|\\*|_|{|}|`|\\||~)+)*)|((\\x22)((((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(([\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x7f]|\\x21|[\\x23-\\x5b]|[\\x5d-\\x7e])|(\([\\x01-\\x09\\x0b\\x0c\\x0d-\\x7f]))))*(((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(\\x22)))@((([a-zA-Z]|\\d)|(([a-zA-Z]|\\d)([a-zA-Z]|\\d|-|\\.|_|~)*([a-zA-Z]|\\d)))\\\.)+(([a-zA-Z])|(([a-zA-Z])([a-zA-Z]|\\d|-|\\.|_|~)*([a-zA-Z])))$';
            const reValidEmail = new RegExp(sValidEmail);
            return reValidEmail.test(punycode.toUnicode(email));
        }
        utils.isValidEmailAddress = isValidEmailAddress;
        function isValidOrderNumber(orderNr) {
            return utils.onlyNumber(orderNr) && orderNr.length === 14;
        }
        utils.isValidOrderNumber = isValidOrderNumber;
        function canNotContainOnlyNumerics(text) {
            const reg = new RegExp('^[0-9]+$');
            return !reg.test(text);
        }
        utils.canNotContainOnlyNumerics = canNotContainOnlyNumerics;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var utils;
    (function (utils) {
        function wait(delay = 0) {
            const deferred = $.Deferred();
            setTimeout(() => deferred.resolve(), delay);
            return deferred.promise();
        }
        utils.wait = wait;
    })(utils = eXpress.utils || (eXpress.utils = {}));
})(eXpress || (eXpress = {}));
